import { ColumnDef } from '@tanstack/react-table';

import { PayScheduleBase } from '@xemplo/gp-types';

import * as S from './modal-styles';

export const payrunSchedulesColumns: ColumnDef<PayScheduleBase>[] = [
  {
    id: 'name',
    accessorKey: 'name',
    header: 'Name',
    enableSorting: false,
  },
  {
    id: 'payschedules',
    accessorKey: 'payschedules',
    header: 'Action',
    enableSorting: false,
    cell: ({ row }) => {
      return (
        <S.ViewPayScheduleNav
          key={row.original.id}
          to={`/payschedule/${row.original.id}`}
          target="_blank"
        >
          View
        </S.ViewPayScheduleNav>
      );
    },
  },
];
